import { useSwaggerlessContext } from 'Context/SwaggerlessContext';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useUserContext from 'Context/UserContext';
import Drawer from 'Components/Ant/Drawer';
import TextArea from 'Components/UI/BehavioralFormElement/NormalizedInput/Textarea';
import RadioGroup from 'Components/UI/BehavioralFormElement/RadioGroup';
import SquareButton from 'Components/UI/SquareButton';
import { withHousehold } from 'Context/HouseholdContext';
import {
  displayErrorMessage,
  displaySuccess,
} from 'Helpers/FacetNotificationManager';
import { removeQuery, QueryVal } from 'Helpers/Query';
import './index.css';

const callTypes = [
  {
    id: 'client-call',
    text: 'Client',
  },
  {
    id: 'advisor-call',
    text: 'Planner',
  },
  {
    id: 'other-call',
    text: 'Other',
  },
];

function CallLogModal({ householdId }) {
  const { createCommunication } = useSwaggerlessContext();
  const { userResource } = useUserContext();
  const agentId = userResource?.attr('agentId');

  const [modal] = useState(QueryVal('modal'));
  const [callType, setCallType] = useState('client-call');
  const [description, setDescription] = useState('');
  const [saving, setSaving] = useState(false);

  function onClose() {
    removeQuery('modal');
  }

  function save() {
    setSaving(true);
    const reqBody = {
      type: 'communication',
      attributes: {
        agentId: agentId.toString(),
        content: description,
        type: callType,
      },
    };
    createCommunication(householdId, reqBody)
      .then(() => {
        displaySuccess('Logged a Call');
        onClose();
        window.dispatchEvent(new Event('timelineReload'));
      })
      .catch(({ response }) => {
        if (response && response.body && response.body.errors) {
          displayErrorMessage(response.body.errors, response.body.errors);
        } else {
          displayErrorMessage(response, 'An Unknown Error Occured');
        }
        setSaving(false);
      });
  }

  function isDisabled() {
    return (
      !(
        callType
        && description
        && description.length
        && description.length >= 10
      ) || saving
    );
  }

  return (
    <Drawer
      className="LogCallModal"
      onClose={onClose}
      title="Add Call"
      visible={modal === 'logCall'}
    >
      <RadioGroup
        name="type"
        options={callTypes}
        value={callType}
        onChange={(_, v) => setCallType(v)}
      />
      <TextArea
        name="description"
        placeholder="Description (min. 10 characters)"
        value={description}
        minRows={4}
        maxLength={6000}
        onChange={(_, v) => setDescription(v)}
      />
      <SquareButton
        color="blue"
        className="saveButton"
        text="Save"
        onClick={save}
        disabled={isDisabled()}
      />
    </Drawer>
  );
}

CallLogModal.propTypes = {
  householdId: PropTypes.number.isRequired,
};

export default withHousehold(CallLogModal);
